import { render } from "./CardGroups.vue?vue&type=template&id=4dd90def&scoped=true"
import script from "./CardGroups.vue?vue&type=script&lang=js"
export * from "./CardGroups.vue?vue&type=script&lang=js"

import "./CardGroups.vue?vue&type=style&index=0&id=4dd90def&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd90def"]])

export default __exports__